import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateClipCropStatusV2Request } from './update-clip-crop-status-v2-request';
import type { IUpdateClipCropStatusV2Response } from './update-clip-crop-status-v2-response';
import { updateClipCropStatusV2ResponseSchema } from './update-clip-crop-status-v2-response';

export async function updateClipCropStatusV2Api({
  clipId,
  body,
}: IUpdateClipCropStatusV2Request): Promise<IValidatedResponse<IUpdateClipCropStatusV2Response>> {
  return putRequest<IUpdateClipCropStatusV2Response>({
    path: `/sys/clips/${clipId}/crop-status/v2`,
    body,
    schema: updateClipCropStatusV2ResponseSchema,
  });
}
